<template>
  <div>
    <div class="wrapper">
      <out-sole v-if="currentKreisslino.bedding.visible"
                class="img-fluid outsole"
                :color="currentKreisslino.outSole.currentColor.variant"
                :imgURL="imgURL"
      ></out-sole>
      <mid-sole v-if="currentKreisslino.midSole.visible"
                class="img-fluid midsole"
                :color="currentKreisslino.midSole.currentColor.variant"
                :imgURL="imgURL"
      ></mid-sole>
      <dummies v-if="!currentKreisslino.midSole.visible"
               class="img-fluid midsole"
               :color="currentKreisslino.bedding.currentColor.variant"
               :variant="currentKreisslino.bedding.variant"
               :imgURL="imgURL"
      ></dummies>
      <bedding v-if="currentKreisslino.midSole.visible"
               class="img-fluid bedding"
               :color=currentKreisslino.bedding.currentColor.variant
               :variant=currentKreisslino.bedding.variant
               :imgURL="imgURL"></bedding>
      <sock v-if="currentKreisslino.sock.visible"
            class="img-fluid sock"
            :color=currentKreisslino.sock.currentColor.variant
            :variant=currentKreisslino.bedding.variant
            :imgURL="imgURL"></sock>
      <bridge v-if="currentKreisslino.bridge"
              class="img-fluid bridge"
              :variant="currentKreisslino.bridge.variant"
              :color="currentKreisslino.bridge.currentColor"
              :wideness="currentKreisslino.bridge.wideness"
              :imgURL="imgURL"
      ></bridge>
      <second-belt v-if="currentKreisslino.secondBelt"
                   class="img-fluid secondbelt"
                   :variant="currentKreisslino.secondBelt.variant"
                   :color="currentKreisslino.secondBelt.currentColor.variant"
                   :wideness="currentKreisslino.secondBelt.wideness"
                   :imgURL="imgURL"
      ></second-belt>
      <belt
        class="img-fluid belt"
        :variant="currentKreisslino.belt.variant"
        :color="currentKreisslino.belt.currentColor.variant"
        :wideness="currentKreisslino.belt.wideness"
        :imgURL="imgURL"
      ></belt>
      <fragment v-if="currentKreisslino.belt.variant!=='Dual'"
        class="img-fluid fragment"
        :variant="currentKreisslino.belt.variant"
        :color="currentKreisslino.belt.currentColor.variant"
        :belt="currentKreisslino.belt.belt"
        :wideness="currentKreisslino.belt.wideness"
        :imgURL="imgURL"
      ></fragment>
      <fragment v-if="currentKreisslino.secondBelt && currentKreisslino.belt.variant!=='Dual'"
                class="img-fluid fragment_bottom"
                :variant="currentKreisslino.secondBelt.variant"
                :color="currentKreisslino.secondBelt.currentColor.variant"
                :belt="currentKreisslino.secondBelt.belt"
                :wideness="currentKreisslino.secondBelt.wideness"
                :imgURL="imgURL"
      ></fragment>
    </div>
  </div>
</template>

<script>
  import Bedding from "./bedding";
  import MidSole from "@/components/midSole";
  import Belt from "./belt";
  import Bridge from "./bridge"
  import OutSole from "@/components/outSole";
  import Fragment from "@/components/fragment";
  import SecondBelt from "./secondBelt";
  import Sock from "./sock";
  import Dummies from "./dummies";

  export default {
    components: {
      Dummies,
      Sock,
      SecondBelt,
      Fragment,
      OutSole,
      MidSole,
      Bedding,
      Belt,
      Bridge
    },
    name: "visual",
    props: {
      currentKreisslino: Object,
      imgURL: String
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/visual.vue